import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "subscription" }
const _hoisted_2 = { class: "subscription__content" }
const _hoisted_3 = { class: "subscription__content__column" }
const _hoisted_4 = { class: "subscription__content__column" }
const _hoisted_5 = { class: "subscription__info" }
const _hoisted_6 = { class: "status-button green" }
const _hoisted_7 = { class: "status-button red" }
const _hoisted_8 = { class: "subscription__footer" }

import {computed} from "vue";
import {format} from "date-fns";
import Icon from "@/components/UI/Icon.vue";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutSubscriptionBlock',
  props: {
    isRecurrent: { type: Boolean },
    price: {},
    expiredDate: {},
    card: {},
    duration: {}
  },
  emits: ['support'],
  setup(__props: any, { emit: __emit }) {


const props = __props
const date = computed<string>(() => format(props.expiredDate, 'dd.MM.yyyy'));
const emit = __emit
const openSupportChat = () => {
  emit('support')
}
const months = computed(() => {
  if (props.duration === 1) return 'мес';
  if (props.duration === 12 ) return 'год';
  return props.duration+'мес';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "subscription__header" }, [
      _createElementVNode("div", { class: "subscription__header__left" }, "ПОДПИСКА PRO"),
      _createElementVNode("div", { class: "subscription__header__right" }, "Активно")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(_ctx.isRecurrent ? 'Дата платежа:' : 'Действует до:'), 1),
        _createElementVNode("div", null, _toDisplayString(date.value) + " г.", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createElementVNode("div", null, "Стоимость:", -1)),
        _createElementVNode("div", null, _toDisplayString(_ctx.price?.toLocaleString('ru-RU')) + " ₽/" + _toDisplayString(months.value) + ".", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isRecurrent)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(Icon, {
                  name: "check",
                  size: 7
                })
              ])
            ]),
            _createElementVNode("div", null, "Подписка продлевается автоматически в дату платежа с карты *" + _toDisplayString(_ctx.card) + ".", 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(Icon, {
                  name: "close",
                  size: 7
                })
              ])
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", null, "Автоматическое продление выключено. Вы можете продлить по завершению текущей подписки.", -1))
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.isRecurrent)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "button button__dark",
            onClick: openSupportChat
          }, "Техническая поддержка"))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "button button__gray" }, "Возобновить подписку", -1)),
            _createElementVNode("div", {
              class: "button button__outline",
              onClick: openSupportChat
            }, "Техническая поддержка")
          ], 64))
    ])
  ]))
}
}

})